import Select from "components/select";
import CountryCode from "components/select/countryCode";
import { useTranslation } from "react-i18next";
import Button from "components/button/default";
import CancelPolicy from "./cancelPolify";
import Term from "./terms";
import { mailOption } from "util/option";
import { useRef } from "react";
import { useBookInfContext } from "components/context/bookInfContext";
import { numRegex } from "util/commAction";
import "./step3.scss";

type IProps = {
  handleJoin(): void;
};

type IOutlet = {
  onFocus: () => void;
  onBlur: () => void;
};

export default function BookStep3({ handleJoin }: IProps) {
  const { t } = useTranslation();
  const { userInf, onUserInf } = useBookInfContext();
  const formRef = useRef<HTMLFormElement>(null);

  // const [inf, setInf] = useState<uerInfProps>(userInf);

  // const userMutation = useMutation({
  //   mutationFn: memInfoApi,
  //   onSuccess: (res) => {
  //     if (res) {
  //       const {
  //         status: { code, message },
  //         data,
  //       } = res;
  //       if (code === 0) {
  //         const { emlId, memFstnm, memSurnm, mobNo, mobCntyCd } = data;
  //         setInf({
  //           cstFstnm: memFstnm,
  //           cstSurnm: memSurnm,
  //           emlId_1: emlId?.split("@")[0],
  //           emlId_2: emlId?.split("@")[1],
  //           emlId_3: "",
  //           cstEml: emlId,
  //           cstMblNo: mobNo,
  //           cstMblCntyCd: mobCntyCd,
  //           reqCn: "",
  //         });
  //       }
  //     }
  //   },
  // });

  // const handleBlur = (name: string, value: string) => {
  //   if (!!name) {
  //     setInf({
  //       ...inf,
  //       [name]: value,
  //     });

  //     setUserInf({
  //       ...userInf,
  //       [name]: value,
  //     });

  //     localStorage.setItem(
  //       "bkUserInf",
  //       JSON.stringify({
  //         ...userInf,
  //         [name]: value,
  //       })
  //     );
  //   }
  // };
  // const handleFocus = () => {};

  // // 입력한 정보로 간편 회원가입
  // const handleJoin = () => {
  //   const { cstEml, emlId_1, emlId_2, emlId_3, reqCn, ...res } = inf;

  //   const params = {
  //     ...res,
  //     emlId: emlId_1 + "@" + (emlId_2 || emlId_3),
  //   };

  //   //이메일, 휴대폰 번호 정규식 체크
  //   if (!emailRegex.test(params.emlId)) {
  //     alertControl({
  //       isOpen: true,
  //       inner: t("alr_reg_mail"),
  //     });
  //     return;
  //   }

  //   if (!phoneRegex.test(params.cstMblNo)) {
  //     alertControl({
  //       isOpen: true,
  //       inner: t("alr_reg_pwd"),
  //     });
  //     return;
  //   }

  //   navigate("/join/term", {
  //     state: params,
  //   });
  // };

  // useEffect(() => {
  //   if (isLogin && bkStep === 3) {
  //     userMutation.mutate();
  //   }
  // }, [isLogin, bkStep]);

  const isAbleJoinBtn = !!(
    userInf.cstFstnm &&
    userInf.cstSurnm &&
    userInf.emlId_1 &&
    (userInf.emlId_2 || userInf.emlId_3) &&
    userInf.cstMblCntyCd &&
    userInf.cstMblNo
  );

  return (
    <div className="insert-inf">
      <h3 className="sub">{t("bck_ttl_inf_bk")}</h3>
      <form className="my-6 " ref={formRef}>
        <ul className="flex flex-col gap-6">
          <li>
            <label htmlFor="dot">{t("lbl_nm_bk")}</label>
            <div className="flex gap-2">
              <input
                type="text"
                name="cstSurnm"
                placeholder={t("plchl_f_nm_cmm")}
                defaultValue={userInf?.cstSurnm ?? ""}
                onChange={(e) => onUserInf("cstSurnm", e.currentTarget.value)}
                required
              />

              <input
                type="text"
                name="cstFstnm"
                placeholder={t("plchl_s_nm_cmm")}
                defaultValue={userInf?.cstFstnm ?? ""}
                onChange={(e) => onUserInf("cstFstnm", e.currentTarget.value)}
                required
              />
            </div>
          </li>
          <li>
            <label htmlFor="dot">{t("lbl_phn_nm_bk")}</label>
            <div className="flex gap-2">
              <CountryCode
                option={userInf?.cstMblCntyCd}
                name={"cstMblCntyCd"}
                styles="flex-1 "
                onChange={(item) => {
                  onUserInf("cstMblCntyCd", "+" + item?.phone);
                }}
              />
              <input
                type="text"
                name="cstMblNo"
                value={userInf?.cstMblNo ?? ""}
                placeholder={t("plchl_nm_cmm")}
                maxLength={11}
                className="flex-1"
                onChange={(e) => {
                  const value = e.currentTarget.value;
                  if (!numRegex.test(value)) {
                    // e.currentTarget.value = "";
                    return;
                  }
                  onUserInf("cstMblNo", e.currentTarget.value);
                }}
                required
              />
            </div>
          </li>
          <li>
            <label htmlFor="dot">{t("lbl_eml_bk")}</label>
            <div className="email-wrap">
              <input
                type="text"
                className="flex-1 mb-[10px] min-w-[120px]  md:mb-0 "
                name="emlId_1"
                defaultValue={userInf.emlId_1 ?? ""}
                onChange={(e) => onUserInf("emlId_1", e.currentTarget.value)}
                required
              />
              <div className="center gap-2">
                <span>@</span>
                <input
                  type="text"
                  className="flex-1 min-w-[120px]"
                  name="emlId_2"
                  defaultValue={userInf.emlId_2 ?? ""}
                  disabled={!!userInf.emlId_3}
                  onChange={(e) => onUserInf("emlId_2", e.currentTarget.value)}
                  required
                />
                <Select
                  name="emlId_3"
                  styles="flex-1 md:flex-none"
                  list={mailOption}
                  defaultValue={(userInf.emlId_3 || mailOption[0]) ?? ""}
                  disabled={!!userInf.emlId_2}
                  onChange={(item) => {
                    onUserInf("emlId_3", item.code);
                  }}
                />
              </div>
            </div>
          </li>
          <li>
            <label htmlFor="">{t("lbl_rqst_bk")}</label>
            <textarea
              placeholder={t("lbl_rqst_bk")}
              name="reqCn"
              defaultValue={userInf?.reqCn ?? ""}
              onChange={(e) => {
                onUserInf("reqCn", e.currentTarget.value);
              }}
            />
          </li>
        </ul>
      </form>
      <Button
        text={t("btn_sgn_inf_bk")}
        styels="radius-4  w-full md:w-[300px]"
        disabled={!isAbleJoinBtn}
        onClick={handleJoin}
      />
      {/* <div className="mt-10">
        <h3 className="sub">투숙객 정보 입력</h3>
        <Guest idx={1} />
      </div> */}
      <CancelPolicy />
      {/* <PayInf />÷ */}
      <Term />
    </div>
  );
}
